import type { ApiClient } from './client';

export const modificationsMethods = {
async getModifications(vehicleId: number): Promise<any[]> {
      const response = await this.makeRequest<any[]>(`/modifications_list.php?vehicle_id=${vehicleId}`);
      return response.data || [];
    },


    async getVendors(): Promise<any[]> {
      const response = await this.makeRequest<any[]>('/vendors_list.php');
      return response.data || [];
    },


    async getCategories(): Promise<Array<{ id: number; name: string; color?: string }>> {
      const response = await this.makeRequest<Array<{ id: number; name: string; color?: string }>>('/categories_list.php');
      return response.data || [];
    },


    async createModification(vehicleId: number, modification: any): Promise<any> {
      try {
        if (!this.isAuthenticated()) {
          throw new Error('Authentication required');
        }

        // Sanitize and validate modification data
        const sanitizedModification = this.sanitizeModificationData(modification);

        const response = await this.makeRequest<any>(`/modifications_create.php`, {
          method: 'POST',
          body: JSON.stringify({
            ...sanitizedModification,
            vehicle_id: vehicleId
          }),
        });

        if (response.success && response.data) {
          return response.data;
        } else {
          throw new Error(response.error || 'Failed to create modification');
        }
      } catch (error: any) {
        console.error('Failed to create modification:', error);
        throw new Error(error.message || 'Failed to create modification');
      }
    },


    async updateModification(id: number, modification: any): Promise<any> {
      if (!this.isAuthenticated()) {
        throw new Error('Authentication required');
      }

      const sanitizedModification = this.sanitizeModificationData(modification);

      const response = await this.makeRequest<any>(`/modifications_update.php?id=${id}`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${this.getAccessToken()}`
        },
        body: JSON.stringify(sanitizedModification),
      });

      if (!response.success) {
        throw new Error(response.error || 'Failed to update modification');
      }

      return response.data;
    },


    async deleteModification(
      id: number,
      options?: { childPolicy?: 'reject' | 'promote' | 'cascade' }
    ): Promise<void> {
      if (!this.isAuthenticated()) {
        throw new Error('Authentication required');
      }

      const policy = options?.childPolicy || 'reject';
      const response = await this.makeRequest<any>(
        `/modifications_delete.php?id=${id}&child_policy=${encodeURIComponent(policy)}`,
        {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${this.getAccessToken()}`
          }
        }
      );

      if (!response.success) {
        throw new Error(response.error || 'Failed to delete modification');
      }
    },

    async organizeModifications(
      vehicleId: number,
      payload: {
        action: 'move' | 'reorder' | 'bulk_move' | 'bulk_category' | 'bulk_delete';
        modification_id?: number;
        modification_ids?: number[];
        parent_modification_id?: number | null;
        before_modification_id?: number | null;
        after_modification_id?: number | null;
        ordered_ids?: number[];
        category?: string;
        include_nested?: boolean;
        child_policy?: 'promote' | 'cascade';
      }
    ): Promise<any> {
      if (!this.isAuthenticated()) {
        throw new Error('Authentication required');
      }

      const response = await this.makeRequest<any>('/modifications_organize.php', {
        method: 'POST',
        body: JSON.stringify({
          vehicle_id: vehicleId,
          ...payload,
        }),
      });

      if (!response.success) {
        throw new Error(response.error || 'Could not update your build');
      }

      return response.data;
    },
} satisfies ThisType<ApiClient>;
